<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Renewal</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- New -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              New <span class="badge badge-pill badge-danger">2</span>
            </h4>
            <p>The table below shows the list of new renewals.</p>
            <div class="table-responsive">
              <table
                id="new_renewal_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product Name</th>
                    <th>Sub Product</th>
                    <th>Certificate Expired</th>
                    <th>Date Renewed</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Customer 6</td>
                    <td>Musafir</td>
                    <td>Kingdom of Saudi Arabia</td>
                    <td>10/01/2019</td>
                    <td>06/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Customer 5</td>
                    <td>Musafir</td>
                    <td>Kingdom of Saudi Arabia</td>
                    <td>10/01/2019</td>
                    <td>05/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- In Process -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">In Process</h4>
            <p>The table below shows the list of in process renewals.</p>
            <div class="table-responsive">
              <table
                id="inprocess_renewal_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product Name</th>
                    <th>Sub Product</th>
                    <th>Certificate Expired</th>
                    <th>Date Renewed</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Customer 4</td>
                    <td>Musafir</td>
                    <td>ASEAN</td>
                    <td>10/01/2019</td>
                    <td>04/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Customer 3</td>
                    <td>Musafir</td>
                    <td>ASEAN</td>
                    <td>10/01/2019</td>
                    <td>03/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />

        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Completed</h4>
            <p>The table below shows the list of completed renewals.</p>
            <div class="table-responsive">
              <table
                id="completed_renewal_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Customer Name</th>
                    <th>Product Name</th>
                    <th>Sub Product</th>
                    <th>Certificate Expired</th>
                    <th>Date Renewed</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Customer 2</td>
                    <td>Musafir</td>
                    <td>Worldwide</td>
                    <td>10/01/2019</td>
                    <td>02/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Customer 1</td>
                    <td>Musafir</td>
                    <td>Worldwide</td>
                    <td>10/01/2019</td>
                    <td>01/01/2019</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded btn-block"
                        style="background-color: #78BE20; border-color: #78BE20;"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "tba_renewal",
  components: {},

  mounted() {
    $("#new_renewal_tbl").DataTable({
      pageLength: 5,
      dom: "Bfrtip",
      buttons: ["excel", "pdf"]
    }),
      $("#inprocess_renewal_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      }),
      $("#completed_renewal_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      });
  }
};
</script>
